import { render, staticRenderFns } from "./PeriodicTable.vue?vue&type=template&id=2e749762"
import script from "./PeriodicTable.vue?vue&type=script&lang=js"
export * from "./PeriodicTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.100.1__lodash@4.17.21_webpack@5.100.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports